import type { Question } from "./data"
import { exportVerifyResults } from "./export"
import { QUESTIONS } from "./questions"
import { backHome } from "./quizState"
import { rerender } from "./render"
import { getReviewResult, type ReviewResult, setReviewResult } from "./storage"

const ACTIONS: { value: ReviewResult; label: string }[] = [
  { value: "verified", label: "Verified" },
  { value: "wrong-answer", label: "Wrong Answer" },
  { value: "wrong-reference", label: "Wrong Reference" },
  { value: "other", label: "Other" },
]

export function Verify() {
  const unverified = QUESTIONS.filter((q) => q.status === "unverified")

  return (
    <>
      <div class="verify-backrow">
        <button type="button" class="btn ghost" onClick={backHome}>
          ← Home
        </button>
      </div>
      <div class="verify-title-block">
        <div class="verify-kicker">Operator</div>
        <h2 class="verify-title">Verify questions</h2>
        <div class="verify-count">
          {unverified.length} unverified question{unverified.length === 1 ? "" : "s"}
        </div>
      </div>

      {unverified.length === 0 ? (
        <div class="verify-empty">No unverified questions to review.</div>
      ) : (
        <>
          <div class="verify-list">
            {unverified.map((q) => (
              <VerifyCard key={q.id} q={q} />
            ))}
          </div>
          <div class="verify-footer">
            <button type="button" class="btn" onClick={exportVerifyResults}>
              Export JSON
            </button>
          </div>
        </>
      )}
    </>
  )
}

function VerifyCard({ q }: { q: Question }) {
  const current = getReviewResult(q)
  return (
    <article class="verify-card">
      <div class="verify-card-meta">
        <span class="verify-card-id">{q.id}</span>
        <span class="verify-card-ref">
          Section {q.answer.section} · Page {q.answer.page}
        </span>
      </div>
      <h3 class="verify-card-q">{q.q}</h3>
      <div class="verify-card-topic">{q.answer.topic}</div>
      <ul class="verify-card-choices">
        <li class="verify-card-choice correct">
          <span class="verify-card-choice-text">{q.answer.text}</span>
          <span class="verify-card-choice-tag">correct</span>
        </li>
        {q.otherChoices.map((c) => (
          <li key={c} class="verify-card-choice">
            <span class="verify-card-choice-text">{c}</span>
          </li>
        ))}
      </ul>
      <div class="flag-row">
        <span class="flag-label">Review:</span>
        {ACTIONS.map((a) => (
          <button
            key={a.value}
            type="button"
            class={`flag-btn${current === a.value ? " active" : ""}`}
            data-status={a.value}
            onClick={() => {
              const next = current === a.value ? null : a.value
              setReviewResult(q, next)
              rerender()
            }}
          >
            {a.label}
          </button>
        ))}
      </div>
    </article>
  )
}
